import { CategoriaPEService } from 'core/http/service/acessosExclusivos/CategoriaPE.service';
import { FerramentaVideoService } from 'core/http/service/ferramentaVideo/FerramentaVideo.service';
import CategoriaPE from 'models/acessoExclusivo/CategoriaPE';
import { IFVPackage } from 'pages/ferramentaVideo/interfaces/FVPackage.interface';
import { useMutation, useQueryClient } from 'react-query';

const service = new FerramentaVideoService();

const getPackageById = async (id: number): Promise<IFVPackage | null> => {
    const { data } = await service.fetchPackageById(id);
    return data;
};

// Accept a single object as argument for useMutation compatibility
const createPackage = async ({ idFerramenta, data }: { idFerramenta: number; data: Omit<IFVPackage, 'id' | 'packageUnits'> }) => {
    try {
        // Add a default id property to satisfy IFVPackage type
        const response = await service.createPackage(idFerramenta, { ...data, url: data.url.trim(), id: -1 });
        return response;
    } catch (error) {
        console.error('Error creating package:', error);
        throw error;
    }
};

const updatePackage = async ({ idFerramenta, data }: { idFerramenta: number; data: Omit<IFVPackage, 'id' | 'packageUnits'> }) => {
    try {
        const response = await service.updatePackage(idFerramenta, { ...data, url: data.url.trim() } as IFVPackage);
        return response;
    } catch (error) {
        console.error('Error updating package:', error);
        throw error;
    }
};

const deletePackage = async ({ packageId }: { packageId: number }) => {
    try {
        const response = await service.deletePackage(packageId);
        return response;
    } catch (error) {
        console.error('Error deleting package:', error);
        throw error;
    }
};

export function useFVPackage() {
    const queryClient = useQueryClient();

    const fetchPackageById = async (id: number): Promise<IFVPackage | null> => {
        return await getPackageById(id);
    };

    const createPackageMutation = useMutation(createPackage, {
        onSuccess: () => {
            queryClient.invalidateQueries('containerToolUnique');
        },
    });

    const updatePackageMutation = useMutation(updatePackage, {
        onSuccess: () => {
            queryClient.invalidateQueries('containerToolUnique');
        },
    });

    const deletePackageMutation = useMutation(deletePackage, {
        onSuccess: () => {
            queryClient.invalidateQueries('containerToolUnique');
        },
    });

    return {
        createPackageMutation,
        updatePackageMutation,
        deletePackageMutation,
        fetchPackageById,
    };
    // Custom hook logic here
}
